import { combineReducers } from "redux";
import activationSlice from "./activationSlice";
import apiSlice from "./apiSlice";
import cronSlice from "./cronSlice";
import crudSlice from "./crudSlice";
import deactivationSlice from "./deactivationSlice";

const logManagementReducer = combineReducers({
	cron: cronSlice,
	crud: crudSlice,
	api: apiSlice,
	activation: activationSlice,
	deactivation: deactivationSlice,
});

export default logManagementReducer;
